import TopView from '@assets/icons/top-view.svg'
import { Icon } from './Icon'

export const TopViewIcon = Icon(TopView)
